<div id="videoModal" #videoModal class="modal" tabindex="-1">
  <div class="d-flex justify-content-center align-items-center">
    <div class="modal-dialog modal-fullscreen" style="width: 70%">
      <div class="modal-content">
        <div class="modal-header">
          <h5 style="font-size: 48px" class="fw-bold">VIDEO TUTORIAL</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body"></div>
        <div class="modal-footer">
          <button
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="btn-custom fw-bold"
            style="padding: 20px 30px; font-size: 24px"
          >
            Entendido!
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
